import { BestType, BestTypeDisplayList, BestTypeString, RankingPagePath } from '@diritto/common/best/constants';
import { CategoryNavigationMenu } from '@diritto/common/navigation/constant';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { RankingNavigationSeriesMenuPath } from 'constants/navigation';
import { useCallback, useMemo } from 'react';
import { Link } from 'ui-components/common/Link';

const BEST_TAB_BORDER_RADIUS = 8;

export const RankingTab = ({
  categoryNavMenu,
  bestType,
  className,
}: {
  categoryNavMenu: CategoryNavigationMenu;
  bestType: BestType;
  className?: string;
}) => {
  const selectedIndex = useMemo(() => BestTypeDisplayList.findIndex(item => item === bestType), [bestType]);

  const getLink = useCallback(
    (type: BestType) => `${RankingNavigationSeriesMenuPath[categoryNavMenu]}/${RankingPagePath[type]}`,
    [categoryNavMenu],
  );

  return (
    <StyledWrapper className={className}>
      <StyledList>
        {BestTypeDisplayList.map((it, index) => (
          <StyledItem key={it} isSelected={selectedIndex === index} selectedIndex={selectedIndex}>
            <Link href={getLink(it)}>
              <StyledTab isSelected={selectedIndex === index}>{BestTypeString[it]}</StyledTab>
            </Link>
          </StyledItem>
        ))}
      </StyledList>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
`;

const StyledList = styled.ul`
  display: flex;
  background-color: ${Color.Gray200};
  width: calc(100% - 40px);
  max-width: 232px;
  height: 35px;
  border-radius: ${BEST_TAB_BORDER_RADIUS}px;
  overflow: hidden;
  padding: 2px;
`;

const StyledTab = styled.p(
  ({ isSelected }: { isSelected: boolean }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20px;
    border-right: 1px solid ${Color.Gray300};
    color: ${isSelected ? Color.Black : Color.Gray600};
    font-weight: ${isSelected ? FontWeight.Bold : FontWeight.Medium};
    ${Typography.XXXSmall};
  `,
);

const StyledItem = styled.li(
  ({ isSelected = false, selectedIndex }: { isSelected?: boolean; selectedIndex: number }) => css`
    flex: 1;
    display: flex;
    justify-content: center;
    height: 100%;
    position: relative;
    border-radius: ${BEST_TAB_BORDER_RADIUS}px;
    overflow: hidden;

    background-color: ${isSelected ? Color.White : 'transparent'};

    & > a {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:nth-of-type(${selectedIndex}) {
      ${StyledTab} {
        border-right: none;
      }
    }

    &:nth-of-type(${selectedIndex + 1}) {
      ${StyledTab} {
        border-right: none;
      }
    }

    &:nth-last-of-type(1) {
      ${StyledTab} {
        border-right: none;
      }
    }
  `,
);
